import { render, staticRenderFns } from "./CollectionNameInput.vue?vue&type=template&id=6d43f844"
import script from "./CollectionNameInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectionNameInput.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports